// @ts-check
import AppStore from "Stores/AppStore";
import migrationStore from "Stores/migrationStore";
import { ShowAlert } from "Utils/CommonFunctions";
import { action } from "mobx";

/**
 * @typedef {{
 * id: string
 * linkTo: string,
 * title: string,
 * icon: string,
 * isDisabled: boolean,
 * isError: boolean,
 * isSelected: boolean,
 * isAvailable: boolean,
 * onClick?: (item: LeftPanelItemState) => void
 * }} LeftPanelItemState
 */

/**
 * @param {string} path
 */
export const MainItems = (path) => {
    let migrationNeeded = migrationStore.migration.migrationNeeded;
    let migrationInProcess = migrationStore.migration.migrationInProcess;

    let onClick = action((/** @type {LeftPanelItemState} */ item) => {
        if (item.isAvailable == false)
            ShowAlert('error', 'Данный раздел сайта недоступен Вам по правам.');
    });

    let isSelected = (/** @type {string} */ linkTo) => path == linkTo || path == `/${linkTo}`;

    let isAvailable = (/** @type {string} */ linkTo) => AppStore.filterAvailablePagesForCurrentUser == null || AppStore.filterAvailablePagesForCurrentUser.some(x => `/${x}` == linkTo);

    let initData = [
        { id: '/users', title: 'Пользователи', icon: 'users-menu', isDisabled: migrationNeeded, isError: false },
        { id: '/mkMessaging', childPaths: ['/mkMessaging/mkMessageList'], title: 'Информирование', icon: 'inform-menu', isDisabled: migrationNeeded, isError: false },
        { id: '/integrationService', title: 'Интеграция', icon: 'integration-menu', isDisabled: migrationInProcess, isError: AppStore.leftPanel.integrationServiceMenuItemHasError },
        { id: '/converter', title: 'Конвертер файлов', icon: 'converter-menu', isDisabled: migrationInProcess, isError: AppStore.leftPanel.converterMenuItemHasError },
        { id: '/stopList', title: 'Стоп-лист', icon: 'stop-list-menu', isDisabled: migrationNeeded, isError: AppStore.leftPanel.stopListMenuItemHasError },
        { id: '/protocolRecords', title: 'Протоколирование', icon: 'protocol-menu', isDisabled: migrationInProcess, isError: false },
        { id: '/documentHistory', title: 'Выгрузка', icon: 'document-history-menu', isDisabled: migrationNeeded, isError: false },
        { id: '/documentReload', title: 'Перезагрузка', icon: 'document-reload-menu', isDisabled: migrationNeeded, isError: false },
        { id: '/stats', title: 'Статистика', icon: 'metrics-menu', isDisabled: migrationNeeded, isError: false },
        { id: '/otherSettings', title: 'Настройки', icon: 'other-settings-menu', isDisabled: migrationNeeded, isError: false },

    ];

    if (migrationNeeded) {
        initData.push({ id: '/migration', title: 'Миграция', icon: 'integration-menu', isDisabled: false, isError: false })
    }

    let visibleFilter = (/** @type {string} */ id) =>
        AppStore.productModeSettings?.filterMainMenuItemsNamesVisible == null ||
        AppStore.productModeSettings?.filterMainMenuItemsNamesVisible.some(v => id.startsWith(v, 1));

    let smrLocation = window.SmrLocation;

    let result = initData
        .filter(x => visibleFilter(x.id))
        .map(x => {
            return {
                id: x.id,
                linkTo: `${smrLocation}${x.id}`,
                title: x.title,
                icon: x.icon,
                isDisabled: x.isDisabled,
                isError: x.isError,
                isSelected: isSelected(x.id) || (x.childPaths?.some(path => isSelected(path)) === true),
                onClick: onClick,
                isAvailable: isAvailable(x.id)
            }
        });

    return result;
};